import { CheckMark, CheckmarkOutline, Close } from '@lyearn/icons';
import { TypographyColors } from '@lyearn/ui';
import { CorrectImageHotspotAnswersFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuestionPerformance';
import { QuizPlayerImageHotspotComponentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerQuestionContent';
import { ImageHotspotResponse } from '@/types/schema';

import { OptionsListItemTypeEnum } from '../../single-select/types';
import { QuizField } from '../../types';

export const isValidImageHotspotSubmission: QuizField['isValidSubmission'] = (
  question,
  submission,
) => {
  return submission?.imageHotspotResponse?.length === question.imageHotspotComponents.length;
};

interface Params {
  imageHotspotComponent: QuizPlayerImageHotspotComponentFragment;
  imageHotspotResponse: ImageHotspotResponse[];
  correctImageHotspotAnswers?: CorrectImageHotspotAnswersFragment[];
}

export const getImageHotspotResponseType = (params: Params) => {
  const { imageHotspotResponse, imageHotspotComponent, correctImageHotspotAnswers } = params;
  const responseAnswer = imageHotspotResponse.find(
    (response) => response.id === imageHotspotComponent?.id,
  );

  const imageHotspotIdToTextMap = getImageHotspotIdToTextMap(correctImageHotspotAnswers);

  if (!responseAnswer) {
    return OptionsListItemTypeEnum.Missed;
  }

  return responseAnswer.text === imageHotspotIdToTextMap[imageHotspotComponent.id]
    ? OptionsListItemTypeEnum.Correct
    : OptionsListItemTypeEnum.Incorrect;
};

export const getImageHotspotIdToTextMap = (
  correctImageHotspotAnswers?: CorrectImageHotspotAnswersFragment[],
) =>
  (correctImageHotspotAnswers || []).reduce(
    (acc, answer) => {
      acc[answer.id] = answer.text || '';
      return acc;
    },
    {} as { [key: string]: string },
  );

type ImageHotspotEvaluationConfig = {
  labelKey: string;
  Icon: typeof CheckmarkOutline;
  iconFillColorToken: string;
  textColor: TypographyColors;
};

export const IMAGE_HOTSPOT_EVALUATION_CONFIG: Record<
  | OptionsListItemTypeEnum.Correct
  | OptionsListItemTypeEnum.Incorrect
  | OptionsListItemTypeEnum.Missed,
  ImageHotspotEvaluationConfig
> = {
  [OptionsListItemTypeEnum.Correct]: {
    labelKey: 'QuizPlayer:Correct',
    Icon: CheckMark,
    iconFillColorToken: 'icon-success',
    textColor: 'text-text-success',
  },
  [OptionsListItemTypeEnum.Incorrect]: {
    labelKey: 'QuizPlayer:Incorrect',
    Icon: Close,
    iconFillColorToken: 'icon-error',
    textColor: 'text-text-error',
  },
  [OptionsListItemTypeEnum.Missed]: {
    labelKey: 'QuizPlayer:Missed',
    Icon: Close,
    iconFillColorToken: 'icon-warning',
    textColor: 'text-text-warning',
  },
};
